<template>
  <Section
    v-bind="$attrs"
    :title="title"
    :shouldShowSearch="shouldShowSearch"
    :toolbarActions="toolbarActions"
    @onClicked="(val) => $emit(val)"
    :isPrimary="isPrimary"
    icon="attachment"
    :isLoading="isLoading"
  >
    <v-data-table
      :headers="headers"
      :items="attachmentList"
      item-key="id"
      class="elevation-1"
      :rows-per-page-items="[15, 25, 50, 100]"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">
          {{ _formatJavascriptDate({ date: props.item.dateTimeUploaded }) }}
        </td>
        <td class="text-xs-left">
          {{ props.item.fileName }}
        </td>
        <td class="text-xs-left">
          {{
            _entityPropertyValueByName({
              entityList: activityTypeList,
              idKey: "id",
              idValue:
                (props.item.activityList[0] &&
                  props.item.activityList[0].typeId) ||
                -1,
              propertyKey: "name",
              emptyText: " ",
            })
          }}
          {{
            _formatJavascriptDate({
              date:
                (props.item.activityList[0] &&
                  props.item.activityList[0].dateTimePerformedOn) ||
                null,
            })
          }}
        </td>
        <td class="text-xs-left">
          {{
            _entityPropertyValueByName({
              entityList: userList,
              idKey: "id",
              idValue: props.item.userIdUploadedBy,
              propertyKey: "name",
            })
          }}
        </td>
        <td class="text-xs-right">
          <ControlButton
            text="Unlink"
            icon="link_off"
            iconColor="error"
            :disabled="isLoading"
            @onClicked="
              $emit('onClickUnlinkAttachment', {
                attachmentId: props.item.id,
                fileName: props.item.fileName,
              })
            "
            v-if="showUnlinkButton"
          />
          <ControlButton
            text="View"
            depressed
            :disabled="isLoading"
            @onClicked="
              $emit('onClickViewAttachment', { attachmentId: props.item.id })
            "
          />
        </td>
      </template>
    </v-data-table>
  </Section>
</template>

<script>
import mixinAssetHelper from '../../../../common/mixins/mixinAssetHelper'

import Section from '../../../../common/components/layouts/Section'
import ControlButton from '../../../../common/components/controls/ControlButton'

export default {
  inheritAttrs: false,
  components: {
    Section,
    ControlButton,
  },
  mixins: [mixinAssetHelper],
  props: {
    toolbarActions: {
      model: Array,
      validator: (val) => {
        return val.every((action) => action.hasOwnProperty('emitEvent'))
      },
    },
    isPrimary: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'Attachments',
    },
    shouldShowSearch: {
      type: Boolean,
    },
    showUnlinkButton: {
      type: Boolean,
      default: false,
    },
    attachmentList: {
      type: Array,
      required: true,
    },
    activityTypeList: {
      type: Array,
      required: true,
    },
    userList: {
      type: Array,
      required: true,
    },
    modelList: {
      type: Array,
      required: true,
    },
    locationList: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    headers: [
      {
        text: 'Uploaded Date',
        value: 'dateTimeUploaded',
        align: 'left',
        sortable: false,
      },
      {
        text: 'File Name',
        value: 'locationId',
        align: 'left',
        sortable: false,
      },
      { text: 'Activity', value: 'activityId', align: 'left', sortable: false },
      {
        text: 'Uploaded By',
        value: 'createdByUserId',
        align: 'left',
        sortable: false,
      },
      { text: '', sortable: false },
    ],
  }),
  computed: {},
  methods: {},
}
</script>
